import { auth } from '../../Firebase';

export const API = process.env.REACT_APP_API_BASE_URL;
export const ADMIN_EMAILS = ['rithmit@gmail.com', 'peachey8@gmail.com', 'peachey8@googlemail.com'];

export const getToken = async () => {
  const token = await auth.currentUser?.getIdToken();
  return token;
};

// "That's me" on a quick-match search / waiting-list row: flags that browser
// as internal and deletes all its searches. Returns { searches, pageViews }.
export const markSearchAsMe = async (searchId) => {
  const token = await getToken();
  const res = await fetch(`${API}/quick-match/admin/thats-me`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ searchId }),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(json.error || 'Failed');
  return json;
};
